import { useState, useEffect } from "react";
import {
  Button,
  Flex,
  Image,
  Tooltip,
  Drawer,
  FloatButton,
  Spin,
  Grid,
} from "antd";

import { MenuOutlined, AppstoreOutlined } from "@ant-design/icons";

import whatsapp from "../assets/images/whatsapp.svg";
import email from "../assets/images/email.svg";
import call from "../assets/images/call.svg";
import logo from "../assets/images/efficient-logo.svg";

import { ReactComponent as HelplineIcon } from "../assets/images/helpline.svg";

import { ReactComponent as LanguageIcon } from "../assets/images/india.svg";

import MegaMenu, { getTabItems } from "./MegaMenu";

import CruiseSearchTabs from "./CruiseSearchTabs";
import CruiseMegaMenu from "./CruiseMegaMenu";

import { Link, useLocation, useNavigate } from "react-router-dom";

import SearchDropdown from "./SearchDropdown";

import axiosInstance from "../api/axiosInstance";

const { useBreakpoint } = Grid;

const Header = ({ classvalue }) => {
  const navigate = useNavigate();

  const location = useLocation();

  const isLandingPage = location.pathname === "/";
  const isCityPage = location.pathname.startsWith("/city/");
  const isHome = location.pathname === "/city";

  const [open, setOpen] = useState(false);

  const [catOpen, setCatOpen] = useState(false);

  const [cruiseOpen, setCruiseOpen] = useState(false);

  const [tabItems, setTabItems] = useState([]);

  const [loadingTabs, setLoadingTabs] = useState(true);

  const screens = useBreakpoint();

  const [activeCategory, setActiveCategory] = useState(0);

  // ✅ FETCH PRODUCTS FOR MOBILE DRAWER
 useEffect(() => {
  const fetchTabs = async () => {
    // Don't call API on landing page
    if (location.pathname === "/") {
      setTabItems([]);
      setLoadingTabs(false);
      return;
    }

    try {
      setLoadingTabs(true);

      const res = await axiosInstance.get(
        "/products?populate=sub_products"
      );

      const products = res?.data?.data || [];

      const tabs = getTabItems(
        products,
        navigate,
        () => setCatOpen(false)
      );

      setTabItems(tabs);
 
    } catch (error) {
      console.log("ERROR FETCHING TABS:", error);
      setTabItems([]);
    } finally {
      setLoadingTabs(false);
    }
  };

  fetchTabs();
}, [location.pathname, navigate]);

  // MENU LIST
  const menuList = (
    <div className="flex flex-col md:flex-row md:items-center md:space-x-8 space-y-4 md:space-y-0 text-sm font-medium">
      {/* Desktop Mega Menu */}
      <div>
        <MegaMenu />
      </div>

      {/* Cruise Desktop */}
      <div className="hidden md:block">
        <CruiseMegaMenu />
      </div>

      {/* Mobile Icons */}
      {!screens.md && (
        <Flex gap="middle" align="center">
          <Tooltip title="Help line">
            <Button
              className="iconButton"
              shape="circle"
              size="large"
              icon={<HelplineIcon />}
            />
          </Tooltip>

          <Tooltip title="Language">
            <Button
              className="iconButton"
              shape="circle"
              size="large"
              icon={<LanguageIcon />}
            />
          </Tooltip>
        </Flex>
      )}

      {/* Mobile Contact */}
      {!screens.md && (
        <Flex gap={16} justify="end" align="right" vertical>
          <Link
            to="/"
            className="flex align-middle gap-1 items-center text-[12px] font-medium"
          >
            <Image width={20} src={whatsapp} preview={false} />

            <span>+971 4 226 9486</span>
          </Link>

          <Link
            to="/"
            className="flex align-middle gap-1 items-center text-[12px] font-medium"
          >
            <Image width={20} src={call} preview={false} />

            <span>+971 4 223 8552</span>
          </Link>

          <Link
            to="/"
            className="flex align-middle gap-1 items-center text-[12px] font-medium"
          >
            <Image width={20} src={email} preview={false} />

            <span>Info@efficienttourism.com</span>
          </Link>
        </Flex>
      )}

      <div className="text-gray-800 hover:text-blue-600 cursor-pointer">
        Efficient Categories
      </div>

      <div className="text-gray-800 hover:text-blue-600 cursor-pointer">
        Popular regions
      </div>

      <div className="text-gray-800 hover:text-blue-600 cursor-pointer">
        Popular destinations
      </div>

      <div className="text-gray-800 hover:text-blue-600 cursor-pointer">
        Popular landmarks
      </div>

      <div className="text-gray-800 hover:text-blue-600 cursor-pointer">
        Explore Efficient Tourism
      </div>
    </div>
  );
  //  navigate(`/activity/${item.key}`);
  return (
    <header className={`${classvalue || ''} bg-white shadow-md`} >
      {/* TOP BAR */}
      <div className="pt-2 pb-0 md:pb-2">
        <div className="container">
          <Flex
            gap={screens.md ? "middle" : 0}
            justify="space-between"
            align="center"
            vertical={!screens.md}
          >
            {/* MOBILE MENU BUTTON */}
            {!screens.md && (
              <Flex
                gap="middle"
                align="center"
                className="absolute left-2 top-5"
              >
                <Button
                  type="text"
                  icon={<MenuOutlined className={`!text-xl md:hidden ${isLandingPage ? 'text-white' : ''}`} />}
                  onClick={() => setOpen(true)}
                />
              </Flex>
            )}

            {/* LOGO */}
            <Link to="/" className="mx-auto md:ml-0">
              <Image
                
                src={logo}
                preview={false}
                className="w-auto max-w-[160px] my-2 md:my-0 convert-white-img"
              />
            </Link>

            {/* DESKTOP RIGHT */}
            {screens.md && (
              <Flex gap={16} justify="end" align="center">
                {!isHome && !isLandingPage && <SearchDropdown size="small" />}

                <Flex
                  gap={16}
                  justify="end"
                  align="right"
                  className="p-4 md:p-0"
                >
                  <Link
                    to="/"
                    className="flex align-middle gap-1 items-center text-[12px] font-medium color-white"
                  >
                    <Image width={20} src={whatsapp} preview={false} />

                    <span>+971 4 226 9486</span>
                  </Link>

                  <Link
                    to="/"
                    className="flex align-middle gap-1 items-center text-[12px] font-medium color-white"
                  >
                    <Image width={20} src={call} preview={false} />

                    <span>+971 4 223 8552</span>
                  </Link>

                  <Link
                    to="/"
                    className="flex align-middle gap-1 items-center text-[12px] font-medium color-white"
                  >
                    <Image width={20} src={email} preview={false} />

                    <span>Info@efficienttourism.com</span>
                  </Link>
                </Flex>
              </Flex>
            )}
          </Flex>
        </div>
      </div>

      {/* DESKTOP NAV */}
      {!isLandingPage && !isCityPage && (
        <div className="hidden md:block border-t border-[#f6f6f6]">
          <div className="container">
            <nav className="flex items-center space-x-8 text-sm font-medium pt-5 pb-7">
              {menuList}
            </nav>
          </div>
        </div>
      )}

      {/* MOBILE SIDE DRAWER */}
      <Drawer
        placement="left"
        onClose={() => setOpen(false)}
        open={open}
        bodyStyle={{
          padding: "1.5rem",
        }}
      >
        {menuList}

        <Button type="primary" size="large" className="mt-6 w-full">
          Login
        </Button>
      </Drawer>

      {/* CRUISE DRAWER */}
      <Drawer
        title="Advance Cruise Search"
        placement="bottom"
        height="80%"
        onClose={() => setCruiseOpen(false)}
        open={cruiseOpen}
        bodyStyle={{
          backgroundColor: "#f9fafb",
          padding: "2rem",
        }}
      >
        <CruiseSearchTabs />
      </Drawer>

      {/* FLOATING BUTTON */}
      <div className="md:hidden fixed bottom-20 right-4 z-50">
        <FloatButton
          icon={<AppstoreOutlined />}
          onClick={() => setCatOpen(true)}
          tooltip="Categories"
        />
      </div>

      {/* MOBILE CATEGORY DRAWER */}
      <Drawer
        title="All Activities"
        placement="bottom"
        onClose={() => setCatOpen(false)}
        open={catOpen}
        height="70%"
      >
        {loadingTabs ? (
          <div className="flex justify-center items-center h-full">
            <Spin size="large" />
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-3">
            {tabItems?.map((item) => (
              <Button
                key={item.key}
                block
                onClick={() => {
                  navigate(`/activity/${item.key}`);

                  setCatOpen(false);
                }}
                className="!h-auto !py-4 !rounded-xl !bg-primary !text-white hover:!bg-danger flex items-center justify-center"
              >
                {item.label}
              </Button>
            ))}
          </div>
        )}
      </Drawer>
      {/* Mobile Drawer */}
      {/* MOBILE CATEGORY DRAWER */}
      <Drawer
        title="All Activities"
        placement="bottom"
        onClose={() => setCatOpen(false)}
        open={catOpen}
        height="75%"
        classNames={{
          body: "!p-0",
        }}
      >
        {loadingTabs ? (
          <div className="flex justify-center items-center h-full">
            <Spin size="large" />
          </div>
        ) : (
          <div className="flex h-full overflow-hidden">
            {/* LEFT CATEGORY LIST */}
            <div className="w-[140px] border-r overflow-y-auto">
              {tabItems?.map((item, index) => (
                <div
                  key={item.key}
                  onClick={() => setActiveCategory(index)}
                  className={`
              p-4 border-b cursor-pointer transition
              ${activeCategory === index
                      ? "bg-primary text-white"
                      : "bg-white text-gray-700"
                    }
            `}
                >
                  <div className="flex flex-col items-center text-center gap-2">
                    <div className="text-lg">
                      {item.label?.props?.children?.[0]}
                    </div>

                    <span className="text-xs font-medium">
                      {item.label?.props?.children?.[1]}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            {/* RIGHT SUB CATEGORIES */}
            <div className="flex-1 overflow-y-auto p-4">
              <div className="flex flex-col gap-3">
                {tabItems?.[activeCategory]?.children?.props?.children?.map(
                  (sub, idx) => (
                    <div
                      key={idx}
                      onClick={sub.props.onClick}
                      className="flex items-center gap-3 p-3 rounded-lg border border-gray-200 hover:bg-primary hover:text-white cursor-pointer transition"
                    >
                      <div className="w-2 h-2 rounded-full bg-current" />

                      <span className="text-sm font-medium">
                        {sub.props.children?.[1]}
                      </span>
                    </div>
                  ),
                )}
              </div>
            </div>
          </div>
        )}
      </Drawer>
    </header>
  );
};

export default Header;
